module.exports = __webpack_public_path__ + "img/9.28c19191.jpg";